module.exports = ":host .m-radio-group {\n  padding: 0 50px; }\n\n:host .u-radio {\n  min-width: 170px; }\n"